import React from 'react'
import TouchLink from '../utils/ope-touch-link'
import OpeProgress from '../app-templates/ope-progress-bar'
import UploadProgressBar from './upload-progress-bar'
import Config from '../../config'
import Sticky from '../../utils/sticky'
import ImageStore from '../../stores/image-store'
import PhotoOrganiser from './sources/photo-organiser'
import Local from './sources/local'
import Gallery from './selector-gallery'
import EditorActions from '../../actions/editor-actions'
import OrderStore from '../../stores/order-store'
import createReactClass from 'create-react-class'
import AdobeAnalytics from '../../utils/adobe-analytics'


var Selector = createReactClass({
    getInitialState: function () {
        return {
            orderItems: OrderStore.getItems(),
            images: ImageStore.getData()
        }
    },

  componentWillMount:function() {
    ImageStore.addChangeListener(this._onImageChange);
    OrderStore.addChangeListener(this._onOrderChange);
    AdobeAnalytics.setImportPhotosPage();
  },
  componentDidMount: function () {

    //Make footer sticky
    var footerNavs = document.getElementsByClassName('ope-section__footer__nav');
    for (var i = 0; i < footerNavs.length; i++) {
      Sticky.setSticky(footerNavs[i], 'stikybottom', 600);
    }

    //In case you have already been on editor page and got a warning popup about
    //crop and low res images, if you come back here we reset that message
    //so that it can be shown again in case you add more photos here.
    EditorActions.setCropLowresWarningSeen(false);
  },
  componentWillUnmount: function() {
    ImageStore.removeChangeListener(this._onImageChange);
    OrderStore.removeChangeListener(this._onOrderChange);
  },

  _onOrderChange: function() {
      this.setState({
          orderItems: OrderStore.getItems()
      });
  },
  _onImageChange: function () {
      this.setState({images: ImageStore.getData()});
  },
  getImageCollectionCount: function () {
    return Object.keys(this.state.images).length;
  },
  getImageSources: function () {
    var sources =  [<Local images={this.state.images} key="imagesource_local" items={this.state.orderItems} />];
    if (Config.VendorVariables[sessionStorage.getItem("vendor")].allowSelectFromPhotoorganise) {
      sources.push(<PhotoOrganiser key="imagesource_photoorganise" />);
    }
    return sources;
  },
  render: function() {
    var selectorClassName = 'ope-selector',
      navDisabled = false;

    if(this.state.orderItems.length === 0) {
      navDisabled = true;
    }
    var imageSources = this.getImageSources();

    if (imageSources.length > 1) {
      selectorClassName += " multiple-sources";
    }

    return (
      <section className={selectorClassName}>
        <UploadProgressBar />
        <OpeProgress progressActiveStates={[true, false, false]} />

        {imageSources}
        <div style={{clear: 'both'}}></div>
        <Gallery images={this.state.images} orderItems={this.state.orderItems} />

        <footer className="ope-section__footer ope-section__footer--no-border">
        <div className="ope-section__footer__seperator">
            <span className="ope-section__footer__seperator-line" />
            <span className="ope-section__footer__seperator-label">{ _("Do more with your photos") } </span>
            <span className="ope-section__footer__seperator-line" />
          </div>
            <div className="ope-section__footer__nav">
              <div className="small-12 medium-5 columns ope-selector__image-count ope-grid-column-nopadding">
                {_("You’re ordering %s photos", this.getImageCollectionCount())}
              </div>
              <div className="small-12 medium-5 columns ope-grid-column-nopadding" style={{textAlign: 'right'}}>
                <TouchLink href="/editor" className="button ope-next-button arrow-right" disabled={navDisabled}>
                  {_("Edit your photos")} <i className="icon arrow-right"></i>
                </TouchLink>
              </div>
            </div>
        </footer>
      </section>
    );
  }
});

export default Selector;
